import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { browserSessionIntegration, browserTracingIntegration, replayIntegration } from '@sentry/angular';
import { environment } from '@kempower-nx-workspace/ce-environment';

// Initialize Sentry before bootstrapping
Sentry.init({
    dsn: environment.sentry.dsn,
    environment: `${environment.appConfig.envType}-${environment.appConfig.envRegion}`,
    integrations: [browserTracingIntegration(), browserSessionIntegration(), replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: environment.production ? 0.2 : 1.0, // Capture 20% of transactions in production
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: environment.sentry.replaySampleRate, // capture replays only on errors
});

// Recover from stale chunk URLs after a deployment.
// esbuild content-hashes chunk filenames — if a user has the old index.html open when a
// new deploy lands, their dynamic imports 404. Reload once to pick up the new index.html.
globalThis.addEventListener('unhandledrejection', (event) => {
    const message = (event.reason as Error)?.message ?? '';
    if (message.includes('Failed to fetch dynamically imported module')) {
        const alreadyReloaded = sessionStorage.getItem('chunk-reload-attempted');
        if (!alreadyReloaded) {
            sessionStorage.setItem('chunk-reload-attempted', '1');
            globalThis.location.reload();
        }
    }
});

// push the environment config to the providers for library access
bootstrapApplication(AppComponent, appConfig).catch((err) => { // NOSONAR - top-level await unavailable in configured browser targets
    console.error(err);
    Sentry.captureException(err);
    throw err;
});
